<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container>
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-item :label="$t('label.materialCode')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <!--<j-search-select-tag-option-is-value-text :disabled="isMmCodeDisabled" @change="mmCodeChanged"
                                                        v-decorator="['mmCode', validatorRules.mmCode]"
                                                        dict="efs_md_group_price_list,mm_name,mm_code,1=1 order by mm_code asc"/>-->
              <a-select :placeholder="$t('label.pleaseSelectTheMaterialNo')"  :disabled="isMmCodeDisabled" showSearch option-filter-prop="children"    v-decorator="['mmCode', validatorRules.mmCode]" @change="mmCodeChanged">
                <a-select-option
                  v-for="item in mmCodeList"
                  :key="item.mmCode"
                  :value="item.mmCode">
                  {{ item.mmName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('label.materialCategory')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-search-select-tag :disabled="isMmCategoryDisabled" v-decorator="['mmCategory']"
                                   dict="efs_md_mm_group,name,code"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('label.materialName')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input :disabled="isMmNameDisabled" v-decorator="['mmName']" :placeholder="$t('label.pleaseEnterTheNameOfTheMaterial')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('label.effectiveDate')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date :placeholder="$t('label.pleaseSelectEffectiveDate')"   v-decorator="['postDate', {'initialValue': initPostDate, rules: validatorRules.postDate.rules}]" :trigger-change="true" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('label.specification')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input :disabled="isSpecDisabled" v-decorator="['spec']" ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('label.model')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input :disabled="isModelDisabled" v-decorator="['model']" ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('label.unitOfMeasurement')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" :disabled="isUnitDisabled" v-decorator="['unit']" :trigger-change="true" dictCode="material_unit_type"  />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('label.unitPrice')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['price', validatorRules.price]" :placeholder="$t('label.pleaseEnterTheUnitPrice')"  style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('label.description')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <!-- <a-input v-decorator="['description', validatorRules.description]" placeholder="请输入说明描述"></a-input> -->
              <mtc-lang-popover :whetherLang="whetherLang('description')" :popLists="getMainTablePop('description')">
                <a-input
                  v-decorator="['description']"
                  :read-only="whetherLang('description')"
                  @click="isLangClick('description', false)"
                  :placeholder="$t('label.pleaseEnterADescription')"
                ></a-input>
              </mtc-lang-popover>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item v-show=false :label="$t('label.validOrNot')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag :disabled="isValidFlagDisabled" type="list" v-decorator="['validFlag', validatorRules.validFlag]"
                                 :trigger-change="true" dictCode="sfyx"  :placeholder="$t('label.pleaseChooseWhetherItIsValidOrNot')"/>
            </a-form-item>
          </a-col>
          <a-col v-if="showFlowSubmitButton" :span="24" style="text-align: center">
            <a-button @click="submitForm">{{$t('button.submit')}}</a-button>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
    <mtc-lang-modal/>
  </a-spin>
</template>

<script>

  import { getAction, httpAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import JSearchSelectTag from '@/components/dict/JSearchSelectTag'
  import {getMdGroupPriceList} from '@/api/api'
  import { mtcLangModalMixin } from '@/mixins/mtcLangModalMixin'
  import moment from 'moment'

  export default {
    name: 'EfsMdCompanyPriceListForm',
    mixins: [mtcLangModalMixin],
    components: {
      JFormContainer,
      JSearchSelectTag
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: () => {
        },
        required: false
      },
      //表单模式：true流程表单 false普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data() {
      return {
        mainTable: 'efs_md_company_price_list',
        // form: this.$form.createForm(this),
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        },
        confirmLoading: false,
          mmCodeList:[],
        validatorRules: {
          mmCode: {
            rules: [
              { required: true, message: this.$t('label.pleaseSelectTheMaterialCommonNameFileNo') }
            ]
          },
          price: {
            rules: [
              { required: true, message: this.$t('label.pleaseEnterTheUnitPrice') }
            ]
          },
          validFlag: {
            rules: [
              { required: true, message: this.$t('label.pleaseChooseWhetherItIsValidOrNot') }
            ]
          },
          postDate: {
              rules: [
                 { required: true, message: this.$t('label.pleaseSelectEffectiveDate')},
              ]
          },
        },

        url: {
          add: '/companyPriceList/efsMdCompanyPriceList/add',
          edit: '/companyPriceList/efsMdCompanyPriceList/edit',
          queryById: '/companyPriceList/efsMdCompanyPriceList/queryById',
          queryByMmCode: '/priceList/groupPriceList/efsMdGroupPriceList/queryByCode'
        },
        isMmCodeDisabled: false,
        isMmCategoryDisabled: true,
        isMmNameDisabled: true,
        isSpecDisabled: true,
        isModelDisabled: true,
        isUnitDisabled: true,
        isValidFlagDisabled: true,
        initPostDate: moment(new Date()).format('YYYY-MM-DD'),
      }

    },
    computed: {
      formDisabled() {
        if (this.formBpm === true) {
          if (this.formData.disabled === false) {
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton() {
        if (this.formBpm === true) {
          if (this.formData.disabled === false) {
            return true
          }
        }
        return false
      }
    },
    created() {
      //如果是流程中表单，则需要加载流程表单data
      this.showFlowData()
    },
    methods: {
      add() {
          getMdGroupPriceList().then((res) => {
              if (res.success) {
                  this.mmCodeList = res.result;
              }
          });
        this.edit({})
      },
      edit(record) {
        this.form.resetFields()
        this.model = Object.assign({}, record)
        this.visible = true
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model, 'mmCode', 'mmCategory', 'mmName', 'spec', 'model', 'unit', 'price', 'description','validFlag','postDate'))
        })
      },
      //渲染流程表单数据
      showFlowData() {
        if (this.formBpm === true) {
          let params = { id: this.formData.dataId }
          getAction(this.url.queryById, params).then((res) => {
            if (res.success) {
              this.edit(res.result)
            }
          })
        }
      },
      submitForm() {
        const that = this
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true
            let httpurl = ''
            let method = ''
            if (!this.model.id) {
              httpurl += this.url.add
              method = 'post'
            } else {
              httpurl+=this.url.edit;
              method = 'put';
            }
            let formData = Object.assign(this.model, values)
            console.log('表单提交数据', formData)
            httpAction(httpurl, formData, method).then((res) => {
              if (res.success) {
                that.$message.success(res.message)
                that.$emit('ok')
              } else {
                that.$message.warning(res.message)
              }
            }).finally(() => {
              that.confirmLoading = false
            })
          }
        })
      },
      popupCallback(row) {
        this.form.setFieldsValue(pick(row, 'mmCode', 'mmCategory', 'mmName', 'spec', 'model', 'unit', 'price', 'description','validFlag','postDate'))
      },
      mmCodeChanged(param) {
        getAction(this.url.queryByMmCode, { code: param }).then(res => {
          if (res.success) {
            this.form.resetFields()
            this.form.setFieldsValue({
              mmCode: res.result.mmCode,
              mmCategory: res.result.mmCategory,
              mmName: res.result.mmName,
              spec: res.result.spec,
              model: res.result.model,
              unit: res.result.unit,
              validFlag: res.result.validFlag,
              price:res.result.price
            })
          } else {
            this.$message.warning(res.message)
          }
        })
      }
    }
  }
</script>